import { motion } from "framer-motion";

const WHATSAPP_NUMBER = "919648881601";
const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Hello Naagarjun Power Fiber, I would like to enquire about FRP components."
)}`;

const WhatsAppIcon = () => (
    <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true">
        <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.6 4.46 1.72 6.4L3.2 28.8l6.56-1.68a12.74 12.74 0 0 0 6.24 1.6c7.06 0 12.8-5.74 12.8-12.8s-5.74-12.72-12.8-12.72zm0 23.28c-1.94 0-3.86-.52-5.54-1.5l-.4-.24-3.9 1 1.04-3.8-.26-.4a10.6 10.6 0 0 1-1.62-5.64c0-5.88 4.8-10.66 10.68-10.66 5.88 0 10.66 4.8 10.66 10.68 0 5.88-4.8 10.56-10.66 10.56zm5.86-7.94c-.32-.16-1.96-.96-2.26-1.08-.3-.12-.52-.16-.74.16-.22.32-.86 1.08-1.06 1.3-.2.22-.38.24-.7.08-.32-.16-1.36-.5-2.6-1.6-.96-.86-1.6-1.92-1.8-2.24-.2-.32-.02-.5.14-.66.14-.14.32-.38.48-.58.16-.2.22-.32.32-.54.1-.22.06-.4-.02-.56-.08-.16-.74-1.8-1.02-2.46-.26-.64-.54-.56-.74-.56h-.64c-.22 0-.58.08-.88.4-.3.32-1.14 1.12-1.14 2.72 0 1.6 1.16 3.14 1.32 3.36.16.22 2.28 3.5 5.54 4.9.78.34 1.38.54 1.86.68.78.24 1.5.2 2.06.12.62-.1 1.96-.8 2.24-1.58.28-.78.28-1.44.2-1.58-.08-.14-.3-.22-.62-.38z" />
    </svg>
);

export const WhatsAppButton = () => (
    <motion.a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-float-button"
        aria-label="Chat on WhatsApp"
        initial={{ opacity: 0, scale: 0.6, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ delay: 1.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.94 }}
        className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-40 w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_8px_30px_rgba(37,211,102,0.35)] border border-[#25D366]"
    >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
        <WhatsAppIcon />
    </motion.a>
);

export default WhatsAppButton;